import { basicConfig } from './basic';
import { partitionedConfig } from './partitioned';
import { asyncConfig } from './async';
import { arrayConfig } from './array';
import { reactSelectConfig } from './react-select';
import { materialUIConfig } from './material-ui';
import { wizardConfig } from './wizard';
import { getterSetterConfig } from './getter-setter';
import { reactWidgetsConfig } from './react-widgets';

export default [
    basicConfig,
    partitionedConfig,
    asyncConfig,
    arrayConfig,
    reactSelectConfig,
    materialUIConfig,
    wizardConfig,
    getterSetterConfig,
    reactWidgetsConfig,
];



// WEBPACK FOOTER //
// ./src/app/redux/configs/index.js